/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateProjectFinancialSummaryCommandResult } from '../../models/create-project-financial-summary-command-result';
import { FinancialSummaryType } from '../../models/financial-summary-type';
import { ProjectFinancialClaimsDetailsVm } from '../../models/project-financial-claims-details-vm';

export interface ApiProjectFinancialSummariesCreateProjectFinancialSummaryPost$Params {
      body?: {
'No'?: number;
'Date'?: string;
'FinancialSummaryType'?: FinancialSummaryType;
'ContractorLetterNumber'?: string;
'ContractorLetterDate'?: string;
'ConsultantLetterNumber'?: string;
'ConsultantLetterDate'?: string;
'OwnerLetterDate'?: string;
'OwnerLetterNumber'?: string;
'From'?: string;
'To'?: string;
'TotalItemsValue'?: number;
'ProjectId'?: string;
'Details'?: Array<ProjectFinancialClaimsDetailsVm>;
'VatValue'?: number;
'FinancialConformityNumber'?: string;
'Attachments'?: Array<Blob>;
}
}

export function apiProjectFinancialSummariesCreateProjectFinancialSummaryPost(http: HttpClient, rootUrl: string, params?: ApiProjectFinancialSummariesCreateProjectFinancialSummaryPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectFinancialSummaryCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectFinancialSummariesCreateProjectFinancialSummaryPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateProjectFinancialSummaryCommandResult>;
    })
  );
}

apiProjectFinancialSummariesCreateProjectFinancialSummaryPost.PATH = '/api/ProjectFinancialSummaries/CreateProjectFinancialSummary';
